export default "__VITE_ASSET__CLVFKYEJ__"